/*
 * LL Familien-Wähler (Marian 2026-11-03): „Für die ganze Familie“ auf jeder Produktseite.
 * Eine Zeile je Person: wer (Erwachsen, Kind, Baby), Größe, Farbe, auf Wunsch ein anderes Motiv derselben Produktart
 * und ein Name. Die Position der Namen wählt man einmal für alle. Preise rechnet der Wähler mit der Staffel aus dem
 * Warenkorb (window.LLKorb.staffel); die echte Rechnung macht Shopify im Korb. Namen und Aufpreis legt er genau so in den
 * Korb wie der Personalisierungs-Block (ll-personalisierung-kauf.js), damit Pick, Presse und Stick sie erkennen.
 */
(function () {
  if (customElements.get('ll-familie')) return;

  var MAX_NAME = 12;
  var MAX_PERSONEN = 8;
  var POS = { BRUST: 'Brust', NACKEN: 'Nacken', KAPUZE: 'Kapuze' };
  var GRUPPEN = { erw: 'Erwachsen', kind: 'Kind', baby: 'Baby' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function geld(c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function pid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  function staffel() { var s = window.LLKorb && window.LLKorb.staffel; return s && s.length ? s : [[2, 5], [3, 10], [4, 20]]; }
  function prozent(n) { var p = 0; staffel().forEach(function (s) { if (n >= s[0]) p = s[1]; }); return p; }
  /* Namen im Familienpaket günstiger (window.LLKorb.namenFamilie, Marian 2026-11-03). */
  function namenFamilie() { return (window.LLKorb && window.LLKorb.namenFamilie) || null; }
  function farbHex(name) { var f = window.LLKorb && window.LLKorb.farben; return (f && f[name]) || null; }
  /* Gleiche Regeln wie im Personalisierungs-Block: „Anna-Lena“, nur Buchstaben, Leerzeichen, Bindestrich. */
  function saeubere(roh) {
    var s = String(roh || '').normalize('NFC').toLocaleLowerCase('de-DE');
    s = s.replace(/[^\p{L}\- ]/gu, '');
    s = s.replace(/(^|[\s-])(\p{L})/gu, function (_, vor, b) { return vor + b.toLocaleUpperCase('de-DE'); });
    return s.replace(/ {2,}/g, ' ').replace(/^ +/, '').slice(0, MAX_NAME);
  }
  function nameFehler(t) {
    t = (t || '').trim();
    if (!t) return 'Bitte gib einen Namen ein.';
    if (t.replace(/[\- ]/g, '').length < 2) return 'Der Name braucht mindestens 2 Buchstaben.';
    if (/^-|-$/.test(t)) return 'Ein Bindestrich kann nicht am Anfang oder Ende stehen.';
    return null;
  }
  function gruppeVon(groesse) {
    var g = String(groesse || '').trim();
    if (/cm/i.test(g)) return 'baby';
    if (/^(X{0,3}S|M|X{0,3}L|\d?XL)$/i.test(g)) return 'erw';
    return 'kind';
  }
  function farbcode(v) { var t = String((v && v.sku) || '').split('-'); return t.length >= 4 ? t[3] : null; }

  /* ---------- Produktdaten ---------- */
  var cache = {};
  function aufbereiten(p) {
    var fi = -1, gi = -1;
    (p.optionen || []).forEach(function (o, i) {
      if (/farbe|color|colour/i.test(o)) fi = i;
      else if (/gr(ö|oe)(ß|ss)e|size/i.test(o)) gi = i;
    });
    if (gi < 0 && (p.optionen || []).length === 1 && fi < 0) gi = 0;
    p.fi = fi; p.gi = gi;
    p.farben = []; p.groessen = [];
    p.varianten.forEach(function (v) {
      var f = fi >= 0 ? v.o[fi] : '', g = gi >= 0 ? v.o[gi] : '';
      if (p.farben.indexOf(f) < 0) p.farben.push(f);
      if (p.groessen.indexOf(g) < 0) p.groessen.push(g);
    });
    p.gruppen = [];
    ['erw', 'kind', 'baby'].forEach(function (k) { if (p.groessen.some(function (g) { return gruppeVon(g) === k; })) p.gruppen.push(k); });
    /* Bild je Farbe wie im Kaufkasten: Kinder-Packshot hinten, sonst vorn, sonst ein Foto der Farbe ohne Baby. */
    p.farbBild = {};
    p.varianten.forEach(function (v) {
      var f = fi >= 0 ? v.o[fi] : '', t = String(v.sku || '').split('-'), c = t.length >= 4 ? t[3].toUpperCase() : null;
      if (!c || p.farbBild[f] !== undefined) return;
      var m = (p.medien || []);
      var such = function (x) { var r = m.filter(function (y) { return y.n.indexOf(c + x) >= 0; })[0]; return r && r.u; };
      p.farbBild[f] = such('-KIDS-BACK') || such('-KIDS-FRONT') || (m.filter(function (y) { return y.n.indexOf('-' + c + '-') >= 0 && y.n.indexOf('BABY') < 0; })[0] || {}).u || null;
    });
    var cfg = p.pers;
    p.positionen = cfg && cfg.aktiv !== false ? (cfg.positionen || []).filter(function (x) { return POS[x]; }) : [];
    cache[p.h] = p;
    return p;
  }
  function ladeProdukt(root, handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=llfam')
      .then(function (r) { if (!r.ok) throw new Error('Motiv nicht ladbar'); return r.json(); })
      .then(aufbereiten);
  }
  /* Ohne Accept-Kopf: mit „application/json“ antwortet Shopify auf ?view= mit 404 (Probe 03.11.). */
  var motivListe = null;
  function ladeMotive(root) {
    if (motivListe) return motivListe;
    var alle = [];
    function seite(n) {
      return fetch(root + 'collections/all?view=llfam&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (d) { alle = alle.concat(d.produkte || []); return d.weiter && n < 10 ? seite(n + 1) : alle; });
    }
    motivListe = seite(1).catch(function () { motivListe = null; return []; });
    return motivListe;
  }

  /* ---------- Element ---------- */
  class LLFamilie extends HTMLElement {
    connectedCallback() {
      if (this._bereit) return;
      this._bereit = true;
      this.root = this.getAttribute('data-root') || '/';
      this.proxy = this.getAttribute('data-proxy') || '/apps/ll/personalisierung/pruefen';
      this.haupt = aufbereiten(JSON.parse(this.querySelector('[data-llf-produkt]').textContent));
      this.aufpreis = JSON.parse(this.querySelector('[data-llf-aufpreis]').textContent);
      this.inhalt = this.querySelector('.llf__inhalt');
      this.knopf = this.querySelector('.llf__auf');
      var start = this.haupt.gruppen.indexOf('erw') >= 0 ? ['erw', 'kind'] : this.haupt.gruppen.slice(0, 2);
      if (start.length < 2) start = [start[0] || 'kind', start[0] || 'kind'];
      var farbe = this._seitenFarbe();
      var self = this;
      this.personen = start.map(function (g) { return self._neuePerson(g, farbe); });
      this.position = null;
      this.motivFuer = -1;
      this.knopf.addEventListener('click', function () {
        var auf = self.knopf.getAttribute('aria-expanded') === 'true';
        self.knopf.setAttribute('aria-expanded', String(!auf));
        self.inhalt.hidden = auf;
        if (!auf) { self.zeichnen(); ladeMotive(self.root); }
      });
      this.inhalt.addEventListener('click', function (e) { self._klick(e); });
      this.inhalt.addEventListener('input', function (e) { self._eingabe(e); });
    }
    _seitenFarbe() {
      var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = form && form.value;
      var v = this.haupt.varianten.filter(function (x) { return String(x.id) === String(id); })[0];
      return v && this.haupt.fi >= 0 ? v.o[this.haupt.fi] : this.haupt.farben[0];
    }
    _neuePerson(gruppe, farbe) {
      return { gruppe: gruppe, produkt: this.haupt, groesse: null, farbe: farbe, mitName: false, name: '', fehler: '' };
    }
    _variante(p) {
      var pr = p.produkt;
      return pr.varianten.filter(function (v) {
        return (pr.fi < 0 || v.o[pr.fi] === p.farbe) && (pr.gi < 0 || v.o[pr.gi] === p.groesse);
      })[0] || null;
    }
    _preis(p) {
      var v = p.groesse ? this._variante(p) : null;
      if (v) return v.preis;
      var pr = p.produkt, min = null;
      pr.varianten.forEach(function (x) {
        if (pr.gi >= 0 && gruppeVon(x.o[pr.gi]) !== p.gruppe) return;
        if (min === null || x.preis < min) min = x.preis;
      });
      return min || 0;
    }
    /* Positionen, die ALLE Teile mit Namen haben; ist die zentrale Wahl bei einem Teil nicht möglich, steht es an der Zeile. */
    _positionen() {
      var mit = this.personen.filter(function (p) { return p.mitName; });
      var alle = [];
      mit.forEach(function (p) { p.produkt.positionen.forEach(function (x) { if (alle.indexOf(x) < 0) alle.push(x); }); });
      return ['BRUST', 'NACKEN', 'KAPUZE'].filter(function (x) { return alle.indexOf(x) >= 0; });
    }
    _positionFuer(p) {
      if (!p.mitName) return null;
      var ps = p.produkt.positionen;
      if (this.position && ps.indexOf(this.position) >= 0) return this.position;
      return ps[0] || null;
    }

    zeichnen() {
      var self = this;
      var h = '<div class="llf__personen">';
      this.personen.forEach(function (p, i) { h += self._personHtml(p, i); });
      h += '</div>';
      if (this.personen.length < MAX_PERSONEN) h += '<button type="button" class="llf__dazu" data-a="dazu">+ Person dazu</button>';
      var pos = this._positionen();
      if (pos.length) {
        if (!this.position || pos.indexOf(this.position) < 0) this.position = pos[0];
        h += '<div class="llf__pos"><div class="llf__label">Position für alle</div><div class="llf__chips">' +
          pos.map(function (x) { return '<button type="button" class="llf__chip" data-a="pos" data-v="' + x + '" aria-pressed="' + (x === self.position) + '">' + POS[x] + '</button>'; }).join('') +
          '</div></div>';
      }
      h += this._summeHtml();
      h += '<button type="button" class="llf__korb" data-a="korb">' + esc(this._korbText()) + '</button><p class="llf__meldung" data-llf-meldung></p>';
      this.inhalt.innerHTML = h;
      if (this.motivFuer >= 0) this._motivWahlZeigen();
    }
    _personHtml(p, i) {
      var pr = p.produkt, self = this;
      var h = '<div class="llf__person" data-i="' + i + '">';
      h += '<div class="llf__kopf"><span class="llf__nr">Person ' + (i + 1) + '</span><div class="llf__chips llf__chips--klein">';
      pr.gruppen.forEach(function (g) { h += '<button type="button" class="llf__chip" data-a="gruppe" data-v="' + g + '" aria-pressed="' + (g === p.gruppe) + '">' + GRUPPEN[g] + '</button>'; });
      h += '</div>' + (this.personen.length > 1 ? '<button type="button" class="llf__weg" data-a="weg" aria-label="Person ' + (i + 1) + ' entfernen">entfernen</button>' : '') + '</div>';
      if (pr.gi >= 0) {
        h += '<div class="llf__chips">';
        pr.groessen.filter(function (g) { return gruppeVon(g) === p.gruppe; }).forEach(function (g) {
          var v = pr.varianten.filter(function (x) { return x.o[pr.gi] === g && (pr.fi < 0 || x.o[pr.fi] === p.farbe); })[0];
          var aus = !v || !v.ok;
          h += '<button type="button" class="llf__chip" data-a="groesse" data-v="' + esc(g) + '" aria-pressed="' + (g === p.groesse) + '"' + (aus ? ' disabled' : '') + '>' + esc(g) + '</button>';
        });
        h += '</div>';
      }
      if (pr.fi >= 0 && pr.farben.length > 1) {
        h += '<div class="llf__farben">';
        pr.farben.forEach(function (f) {
          var hex = farbHex(f), bild = pr.farbBild && pr.farbBild[f];
          h += bild
            ? '<button type="button" class="llf__farbe llf__farbe--bild" data-a="farbe" data-v="' + esc(f) + '" aria-pressed="' + (f === p.farbe) + '" title="' + esc(f) + '"><img src="' + esc(bild) + '" alt="" width="56" height="56" loading="lazy"><span class="llf__sr">' + esc(f) + '</span></button>'
            : '<button type="button" class="llf__farbe" data-a="farbe" data-v="' + esc(f) + '" aria-pressed="' + (f === p.farbe) + '" title="' + esc(f) + '">' +
              (hex ? '<span style="background:' + hex + '"></span>' : '') + esc(f) + '</button>';
        });
        h += '</div>';
      }
      h += '<div class="llf__zeile2"><button type="button" class="llf__motiv" data-a="motiv"><img src="' + esc(pr.bild) + '" alt="" width="28" height="28" loading="lazy"><span>' +
        (pr.h === self.haupt.h ? 'Motiv wie oben' : esc(pr.t)) + '</span><em>ändern</em></button>';
      if (pr.positionen.length && this.aufpreis) {
        h += p.mitName
          ? '<button type="button" class="llf__name-weg" data-a="nameweg">ohne Personalisierung</button>'
          : '<button type="button" class="llf__plus" data-a="name" aria-label="Personalisierung dazu">+ Personalisierung <small>' + geld(this._namenPreis()) + (this._namenPreis() < this.aufpreis.preis ? ' statt ' + geld(this.aufpreis.preis) : '') + '</small></button>';
      }
      h += '</div>';
      if (p.mitName) {
        var pos = this._positionFuer(p);
        var abweichend = this.position && pos !== this.position;
        h += '<div class="llf__name"><input type="text" id="llf-name-' + i + '" data-a="nameein" maxlength="' + MAX_NAME + '" autocomplete="off" autocapitalize="none" spellcheck="false" placeholder="Name" value="' + esc(p.name) + '" aria-label="Name für Person ' + (i + 1) + '">' +
          '<span class="llf__zaehler">' + p.name.length + ' / ' + MAX_NAME + '</span></div>' +
          (abweichend && pos ? '<p class="llf__hinweis">Bei diesem Teil geht ' + POS[this.position] + ' nicht, der Name kommt auf ' + POS[pos] + '.</p>' : '') +
          (p.fehler ? '<p class="llf__fehler">' + esc(p.fehler) + '</p>' : '');
      }
      h += '</div>';
      return h;
    }
    _namenPreis() {
      var nf = namenFamilie();
      return nf && this.personen.length >= nf.ab ? nf.preis : (this.aufpreis ? this.aufpreis.preis : 0);
    }
    _summen() {
      var self = this, summe = 0, namen = 0;
      this.personen.forEach(function (p) { summe += self._preis(p); if (p.mitName) namen++; });
      var n = this.personen.length, pz = prozent(n), rabatt = Math.round(summe * pz / 100);
      var aufpreis = this.aufpreis ? namen * this._namenPreis() : 0;
      return { n: n, summe: summe, pz: pz, rabatt: rabatt, namen: namen, aufpreis: aufpreis, zusammen: summe - rabatt + aufpreis, ab: this.personen.some(function (p) { return !p.groesse; }) };
    }
    _summeHtml() {
      var s = this._summen();
      var h = '<div class="llf__summe">';
      h += '<div class="llf__z"><span>' + s.n + (s.n === 1 ? ' Teil' : ' Teile') + '</span><span>' + (s.ab ? 'ab ' : '') + geld(s.summe) + '</span></div>';
      if (s.pz) h += '<div class="llf__z llf__z--rabatt"><span>' + (s.n >= staffel()[staffel().length - 1][0] ? 'Familienpreis' : 'Mehr-Teile-Preis') + ' −' + s.pz + ' %</span><span>−' + geld(s.rabatt) + '</span></div>';
      if (s.namen) h += '<div class="llf__z"><span>' + s.namen + ' × Personalisierung' + ' je ' + geld(this._namenPreis()) + '</span><span>' + geld(s.aufpreis) + '</span></div>';
      h += '<div class="llf__z llf__z--gross"><span>Zusammen</span><span>' + (s.ab ? 'ab ' : '') + geld(s.zusammen) + '</span></div>';
      if (s.n > 1) h += '<div class="llf__klein">je Teil ' + geld(Math.round((s.summe - s.rabatt) / s.n)) + '</div>';
      var naechste = staffel().filter(function (x) { return x[0] > s.n; })[0];
      h += '<div class="llf__tipp">' + (naechste
        ? 'Noch ' + (naechste[0] - s.n) + (naechste[0] - s.n === 1 ? ' Teil mehr' : ' Teile mehr') + ', dann −' + naechste[1] + ' % auf alles'
        : 'Familienpreis aktiv, Socken gratis dazu') + '</div>';
      h += '</div>';
      return h;
    }
    _korbText() { var s = this._summen(); return s.n === 1 ? 'In meine Tasche' : 'Alle ' + s.n + ' in meine Tasche'; }

    _klick(e) {
      var b = e.target.closest('[data-a]');
      if (!b || b.disabled) return;
      var a = b.getAttribute('data-a'), v = b.getAttribute('data-v');
      /* Klick ins Namensfeld: nichts neu zeichnen, sonst verliert das Feld den Fokus (Marian 2026-11-03). */
      if (a === 'nameein') return;
      var pe = b.closest('.llf__person');
      var i = pe ? +pe.getAttribute('data-i') : -1;
      var p = i >= 0 ? this.personen[i] : null;
      if (a === 'dazu') {
        var letzte = this.personen[this.personen.length - 1];
        var neuP = this._neuePerson('kind', letzte ? letzte.farbe : this.haupt.farben[0]);
        neuP.produkt = letzte ? letzte.produkt : this.haupt;
        if (neuP.produkt.gruppen.indexOf('kind') < 0) neuP.gruppe = neuP.produkt.gruppen[0];
        this.personen.push(neuP);
      }
      else if (a === 'weg') { this.personen.splice(i, 1); }
      else if (a === 'gruppe') { p.gruppe = v; p.groesse = null; }
      else if (a === 'groesse') { p.groesse = v; p.fehler = ''; }
      else if (a === 'farbe') { p.farbe = v; if (p.groesse) { var vv = this._variante(p); if (!vv || !vv.ok) p.groesse = null; } }
      else if (a === 'name') { p.mitName = true; this.zeichnen(); var f = this.inhalt.querySelector('#llf-name-' + i); if (f) f.focus(); return; }
      else if (a === 'nameweg') { p.mitName = false; p.name = ''; p.fehler = ''; }
      else if (a === 'pos') { this.position = v; }
      else if (a === 'motiv') { this.motivFuer = this.motivFuer === i ? -1 : i; }
      else if (a === 'motivwahl') { this._motivSetzen(this.motivFuer, v); return; }
      else if (a === 'motivzu') { this.motivFuer = -1; }
      else if (a === 'korb') { this._inKorb(b); return; }
      this.zeichnen();
    }
    _eingabe(e) {
      var f = e.target;
      if (f.getAttribute('data-a') !== 'nameein') return;
      var i = +f.closest('.llf__person').getAttribute('data-i');
      var sauber = saeubere(f.value);
      if (sauber !== f.value) { var pos = f.selectionStart; f.value = sauber; try { f.setSelectionRange(pos, pos); } catch (x) {} }
      this.personen[i].name = sauber;
      this.personen[i].fehler = '';
      var z = f.parentNode.querySelector('.llf__zaehler');
      if (z) z.textContent = sauber.length + ' / ' + MAX_NAME;
    }
    _motivWahlZeigen() {
      var self = this, i = this.motivFuer;
      var person = this.inhalt.querySelector('.llf__person[data-i="' + i + '"]');
      if (!person) return;
      var box = document.createElement('div');
      box.className = 'llf__motive';
      box.innerHTML = '<div class="llf__label">Motiv für Person ' + (i + 1) + ' <button type="button" class="llf__weg" data-a="motivzu">schließen</button></div><div class="llf__raster">Motive werden geladen …</div>';
      person.appendChild(box);
      ladeMotive(this.root).then(function (liste) {
        var typ = self.haupt.typ;
        var passend = liste.filter(function (m) { return m.typ === typ && m.ok; });
        if (!passend.length) passend = [{ h: self.haupt.h, t: self.haupt.t, bild: self.haupt.bild }];
        var aktuell = self.personen[i] && self.personen[i].produkt.h;
        box.querySelector('.llf__raster').innerHTML = passend.map(function (m) {
          return '<button type="button" class="llf__m" data-a="motivwahl" data-v="' + esc(m.h) + '" aria-pressed="' + (m.h === aktuell) + '"><img src="' + esc(m.bild) + '" alt="" loading="lazy" width="80" height="80"><span>' + esc(m.t) + '</span></button>';
        }).join('');
      });
    }
    _motivSetzen(i, handle) {
      var self = this, p = this.personen[i];
      ladeProdukt(this.root, handle).then(function (pr) {
        p.produkt = pr;
        if (pr.farben.indexOf(p.farbe) < 0) p.farbe = pr.farben[0];
        if (pr.gruppen.indexOf(p.gruppe) < 0) p.gruppe = pr.gruppen[0];
        if (p.groesse && pr.groessen.indexOf(p.groesse) < 0) p.groesse = null;
        if (p.groesse) { var v = self._variante(p); if (!v || !v.ok) p.groesse = null; }
        if (!pr.positionen.length) { p.mitName = false; p.name = ''; }
        self.motivFuer = -1;
        self.zeichnen();
      }).catch(function () { self._meldung('Das Motiv ließ sich nicht laden. Versuch es bitte noch einmal.'); });
    }
    _meldung(t) { var m = this.inhalt.querySelector('[data-llf-meldung]'); if (m) m.textContent = t; }

    _inKorb(knopf) {
      var self = this, fehlt = false;
      this.personen.forEach(function (p) {
        p.fehler = '';
        if (!p.groesse && p.produkt.gi >= 0) { p.fehler = 'Bitte wähl eine Größe.'; fehlt = true; }
        if (p.mitName) { var f = nameFehler(p.name); if (f) { p.fehler = f; fehlt = true; } }
      });
      if (fehlt) { this.zeichnen(); this._meldung('Bitte ergänze die rot markierten Angaben.'); return; }
      knopf.disabled = true;
      knopf.textContent = 'Einen Moment …';
      var familie = pid();
      var pruefungen = this.personen.map(function (p) {
        if (!p.mitName) return Promise.resolve(null);
        return fetch(self.proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ text: p.name, position: self._positionFuer(p), produkt: String(p.produkt.id) }),
        })
          .then(function (r) { return r.ok ? r.json() : { ok: true, druck: p.name, pruefen: true }; })
          .catch(function () { return { ok: true, druck: p.name, pruefen: true }; });
      });
      Promise.all(pruefungen).then(function (antworten) {
        var nein = false;
        antworten.forEach(function (a, i) { if (a && !a.ok) { self.personen[i].fehler = a.fehler || 'Diesen Namen können wir leider nicht sticken.'; nein = true; } });
        if (nein) throw { neu: true };
        var items = [];
        self.personen.forEach(function (p, i) {
          var v = self._variante(p);
          var props = { _ll_familie: familie };
          var a = antworten[i];
          if (a) {
            var gedruckt = a.druck || p.name, id = pid(), pos = self._positionFuer(p);
            var titel = ((p.produkt.pers && p.produkt.pers.texte && p.produkt.pers.texte[pos]) || {}).titel || POS[pos];
            props = { Personalisierung: gedruckt, Position: titel, _pid: id, _print: gedruckt, _ll_familie: familie };
            var tinte = ((p.produkt.pers && p.produkt.pers.tinte) || {})[farbcode(v)];
            if (tinte) props._ink = tinte;
            if (a.pruefen) props._review = '1';
            items.push({ id: self.aufpreis.id, quantity: 1, properties: { 'Für': gedruckt + ' · ' + titel, _parent: id } });
          }
          items.push({ id: v.id, quantity: 1, properties: props });
        });
        return fetch(self.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items }),
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw { meldung: j.description || j.message }; return j; }); });
      }).then(function () {
        return fetch(self.root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          /* Nur für den Zähler im Kopf; „variant:add“ würde Prestige nach Abschnitten suchen lassen, die es hier nicht gibt.
             Den LL-Korb öffnet schon dessen Abruf-Wächter auf /cart/add.js. */
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'll:familie', cart: cart } }));
          self.zeichnen();
          self._meldung('Alle ' + self.personen.length + ' Teile liegen in deiner Tasche.');
        });
      }).catch(function (f) {
        self.zeichnen();
        self._meldung(f && f.neu ? 'Ein Name lässt sich so nicht sticken, bitte prüf die rot markierte Zeile.' : (f && f.meldung) || 'Das hat nicht geklappt. Versuch es bitte noch einmal.');
      });
    }
  }
  customElements.define('ll-familie', LLFamilie);
})();
